import { useAudienceDailyCountsQuery } from '@occc/graphql';

export const useGetAudienceMetricsById = (
  audienceId: string,
  startDate: string,
  endDate: string,
  chainIdEquals?: string,
) => {
  const response = useAudienceDailyCountsQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        uuidEquals: audienceId,
        ...(chainIdEquals ? { chainIdEquals } : {}),
      },
      startDate,
      endDate,
    },
  });

  const node = response.data?.audiences?.edges[0]?.node;
  return {
    ...response,
    data: node,
    loaded: !!node,
  };
};
